<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="1300">
      <v-card class="align-center text-center">
        <v-card-text>
          <div class="pt-5 d-flex align-center justify-space-between">
            <div>
              <h1>Upload XML Cte</h1>
            </div>
            <v-btn icon @click="close()" class="align-self-end">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="d-flex align-left text-left">
            <v-btn elevation="2" class="my-5 d-flex align-left text-left" color="success" @click="showFilePicker">
              Anexar XML
            </v-btn>
            <v-tooltip right nudge-top="1">
              <template #activator="{ attrs, on }">
                <v-icon class="mx-2" v-bind="attrs" v-on="on" size="20"> mdi-information-outline </v-icon>
              </template>
              <span
                >Os arquivos xml anexados precisam seguir o padrão original da emissão de CTes. <br />
                EX: 34231124552279000184570010008992391000000000_v03.00-procCTe.xml</span
              >
            </v-tooltip>
          </div>
          <v-file-input
            ref="fileInput"
            multiple
            accept=".xml, text/xml"
            v-model="files"
            @change="addFiles"
            class="d-none"
          >
          </v-file-input>
          <v-data-table
            :headers="fileHeaders"
            :items="filesTable"
            :items-per-page="filesTable.length"
            :height="tableHeight"
            no-data-text="Sem arquivos selecionados"
            hide-default-footer
          >
            <template v-slot:[`item.actions`]="{ index }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" @click="remove(index)" icon color="red" dark>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pb-5">
          <v-btn color="error" class="flex-grow-1" large @click="close()"> Cancelar </v-btn>
          <v-btn color="success" class="flex-grow-1" large :disabled="!files.length" @click="isOpenValidation = true">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <import-confirm-dialog
      :isOpen.sync="isOpenValidation"
      @confirmClick="uploadXml()"
      :is-confirm-btn-loading="isUploadLoading"
      title="Confirmar Importação"
      body-text="Você confirma a importação desses arquivos XML?"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ImportConfirmDialog from '@/components/ConfirmDialog.vue';
import Base64Mixin from '@/mixins/base64.mixin';

export default {
  name: 'UploadXmlCte',
  props: {
    isOpen: {
      default: false,
      type: Boolean
    }
  },
  components: {
    ImportConfirmDialog
  },
  mixins: [Base64Mixin],
  data() {
    return {
      isUploadLoading: false,
      files: [],
      filesBackup: [],
      documentImportXml: [],
      isOpenValidation: false,
      fileHeaders: [
        {
          value: 'fileName',
          text: 'NOME DO ARQUIVO',
          sortable: true
        },
        {
          value: 'accessKeyCte',
          text: 'CHAVE CTE',
          sortable: true
        },
        {
          value: 'numberCte',
          text: 'NÚMERO CTE',
          sortable: true
        },
        {
          value: 'actions',
          align: 'end',
          text: '',
          sortable: false
        }
      ]
    };
  },

  computed: {
    getFilenames() {
      const filenames = this.files.map((file) => file.name.split('_')[0]);
      return filenames;
    },

    filesTable() {
      const files = this.files.map((file) => {
        const accessKeyCte = file.name.split('_')[0];
        return {
          fileName: file.name,
          accessKeyCte: accessKeyCte,
          numberCte: accessKeyCte.substring(25, 34)
        };
      });
      return files;
    },

    tableHeight() {
      const hasMoreThanTen = this.files.length > 10;
      return hasMoreThanTen ? '450' : '';
    }
  },

  methods: {
    ...mapActions('ImportXmlStore', ['uploadXmlCte']),

    addFiles(newFiles) {
      if (newFiles.length) {
        this.filesBackup = [...new Set([...this.filesBackup, ...newFiles])];

        this.files = [...this.filesBackup];

        const uniqueFiles = Array.from(new Set(this.files.map((f) => f.name))).map((name) => {
          return this.files.find((f) => f.name === name);
        });

        this.files = [...uniqueFiles];
      }
    },

    showFilePicker() {
      const input = this.$refs.fileInput.$el.querySelector('input[type="file"]');
      input.click();
    },

    remove(index) {
      this.files.splice(index, 1);
      this.filesBackup = [...this.files];
    },

    async uploadXml() {
      try {
        this.isUploadLoading = true;

        for (const file of this.files) {
          const dataFiles = await this.toBase64(file);
          const documentsXml = {
            fileName: file.name,
            dataFiles: dataFiles.split('base64,')[1]
          };
          this.documentImportXml.push(documentsXml);
        }

        const data = await this.uploadXmlCte(this.documentImportXml);
        if (data.success) {
          this.handleSuccessFeedback();
        } else {
          this.errors = data.errors;
          this.errorsType = 'error';
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.close();
        this.documentImportXml = [];
        this.isUploadLoading = false;
      }
    },

    handleSuccessFeedback() {
      this.errors = ['Arquivos importados com sucesso!'];
      this.errorsType = 'success';
      this.$emit('shouldUpdateList');
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    },

    clearFiles() {
      this.files = [];
      this.filesBackup = [];
    },

    close() {
      this.clearFiles();
      this.isOpenValidation = false;
      this.$emit('update:isOpen', false);
      setTimeout(() => {
        this.errors = [];
      }, 5000);
    }
  }
};
</script>

<style lang="scss" scoped></style>
